<template>
  <div class="container">
    <section>
      <img src="../assets/images/logo_et.png" alt="Effectual Infotech" />
      <h2>Welcome To Effectual Project Managment</h2>
      <div class="loginLink">
          <base-button to="/home" link>Login to countinue</base-button>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style  scoped>
.container{margin-top:15%;}
</style>